import {ActiveRecord} from '../ActiveRecord';
import config from 'config';
import {StreamImageDTO} from "./CustomStreamEvent";
import {AwsVideo} from '../videoAws';
import {CountryDTO} from "../country";

export interface VoDEventDTO {
  id?: string;
  title: string;
  full_name?: string;
  logo?: StreamImageDTO | Blob;
  video?: Blob;
  m3u8?: string;
  description: string;
  vip_only?: boolean;
  trigger_push_notifications?: boolean;
  push_notifications_triggered?: boolean;
  countries?: CountryDTO[];
  country_codes?: Array<string>;
  m3u8_url?: string;
  category_id?: string;
  order_number?: number;
}

export class VoDEvent extends ActiveRecord {

  countries: Array<string>;
  vip_only: boolean = false;

  static path = `${config.backOfficeBasePath}/custom_streams/vods`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: VoDEventDTO): VoDEvent {
    let res = new VoDEvent({});

    return Object.assign(res, res._parseData(data));
  }

  prepareForSave(data): VoDEventDTO {
    return {
      title: data.title,
      logo: data.logo && !data.logo.isSaved ? data.logo.file : undefined,
      m3u8: data.video ? data.video.url : undefined,
      description: data.description,
      vip_only: data.vip_only,
      trigger_push_notifications: data.trigger_push_notifications,
      country_codes: data.countries,
      category_id: data.category_id,
      order_number: data.order_number
    };
  }

  _parseData(data: VoDEventDTO) {
    let res: any = {
      id: data.id,
      title: data.full_name,
      logo: data.logo,
      video: new AwsVideo({isSaved: true, url: data.m3u8}),
      description: data.description,
      vip_only: data.vip_only,
      trigger_push_notifications: data.id ? false: true,
      push_notifications_triggered: data.push_notifications_triggered || false,
      countries: data.countries.map(country => country.code),
      category_id: data.category_id,
      order_number: data.order_number
    };

    return res;
  }

  async publish(data): Promise<VoDEvent> {
    return <VoDEvent> await this.save(data);
  }

  protected async _createRecord(dataForSave) {
    return await this._networkLayer.postFormData(this._prepareUrl(), dataForSave)
  }

  protected async _updateRecord(dataForSave) {
    let res = await this._networkLayer.patchFormData(this._prepareUrl(this.id), dataForSave);
    return await res.json();
  }
}



// WEBPACK FOOTER //
// ./src/api/stream/VoDEvent.ts